"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2311],{

/***/ 87246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CredexUserPromoBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./lib/templateToJsx.js
var templateToJsx = __webpack_require__(60024);
;// CONCATENATED MODULE: ./components/CredexUserPromoBanner/CredexUserPromoBannerDefaultLabel.js


var CredexUserPromoBannerDefaultLabel = function(param) {
    var firstName = param.firstName, credexConfig = param.credexConfig;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            firstName && credexConfig.bannerTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[14px] font-medium",
                children: (0,templateToJsx/* default */.Z)(credexConfig.bannerTitle, {
                    firstName: firstName
                })
            }),
            credexConfig.bannerSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[12px]",
                children: credexConfig.bannerSubTitle
            })
        ]
    });
};
/* harmony default export */ var CredexUserPromoBanner_CredexUserPromoBannerDefaultLabel = (CredexUserPromoBannerDefaultLabel);

;// CONCATENATED MODULE: ./components/CredexUserPromoBanner/CredexUserPromoBannerExtraInfoLabel.js


var CredexUserPromoBannerExtraInfoLabel = function(param) {
    var firstName = param.firstName, credexConfig = param.credexConfig, installmentValue = param.installmentValue;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col",
        children: [
            firstName && credexConfig && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[14px] font-medium",
                children: (0,templateToJsx/* default */.Z)(credexConfig.productPageLabel.userPromo, {
                    firstName: firstName,
                    promoRates: credexConfig.promoRates,
                    promoInterest: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: credexConfig.promoInterest
                    }),
                    installmentValue: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: installmentValue
                    })
                })
            }),
            credexConfig.bannerSubTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-[12px]",
                children: credexConfig.bannerSubTitle
            })
        ]
    });
};
/* harmony default export */ var CredexUserPromoBanner_CredexUserPromoBannerExtraInfoLabel = (CredexUserPromoBannerExtraInfoLabel);

;// CONCATENATED MODULE: ./components/CredexUserPromoBanner/index.js





var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var layoutLabel = {
    default: CredexUserPromoBanner_CredexUserPromoBannerDefaultLabel,
    extraInfo: CredexUserPromoBanner_CredexUserPromoBannerExtraInfoLabel
};
// Bussiness has revoked credex modal. Development code is not finished but kept for future reference.
var CredexUserPromoBanner = function(param) {
    var _layout = param.layout, layout = _layout === void 0 ? "default" : _layout, customer = param.customer, installmentValue = param.installmentValue, credexConfig = param.credexConfig;
    var LabelComponent = layoutLabel[layout];
    if (!credexConfig || !customer) {
        return null;
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative flex items-center justify-between gap-[8px] overflow-hidden rounded-[4px] text-white bg-cover bg-top bg-no-repeat px-[16px] py-[12px]",
        role: "region",
        "aria-label": "informational-banner",
        style: {
            backgroundImage: "url(".concat(settings.websiteStatics, "/images/credex/credex-customer-promo.png)")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "z-[2]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelComponent, {
                firstName: customer === null || customer === void 0 ? void 0 : customer.first_name,
                credexConfig: credexConfig,
                installmentValue: installmentValue
            })
        })
    }));
};
/* harmony default export */ var components_CredexUserPromoBanner = ((0,es/* connect */.$j)(function(state) {
    return {
        customer: state.user.customer,
        credexConfig: state.credex.data
    };
})(CredexUserPromoBanner));


/***/ }),

/***/ 42009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, _footprints = _publicRuntimeConfig.footprints, desktopWebAdvertisementScriptUrl = _footprints.desktopWebAdvertisementScriptUrl, mobileWebAdvertisementScriptUrl = _footprints.mobileWebAdvertisementScriptUrl;
var MOBILE_FOOTPRINTS_SCRIPT_ID = "FootprintsWebAdsMobileScript";
var DESKTOP_FOOTPRINTS_SCRIPT_ID = "FootprintsWebAdsDesktopScript";
var FootprintsWebAdsBanner = function(param) {
    var _desktopSize = param.desktopSize, desktopSize = _desktopSize === void 0 ? "728x90" : _desktopSize, _mobileSize = param.mobileSize, mobileSize = _mobileSize === void 0 ? "320x50" : _mobileSize;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), mobileScriptLoaded = ref2[0], setMobileScriptLoaded = ref2[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), desktopScriptLoaded = ref1[0], setDesktopScriptLoaded = ref1[1];
    var loadScript = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        // Add the mobile script
        var mobileScript = document.createElement("script");
        mobileScript.src = mobileWebAdvertisementScriptUrl;
        mobileScript.id = MOBILE_FOOTPRINTS_SCRIPT_ID;
        mobileScript.async = true;
        mobileScript.onload = setMobileScriptLoaded(true);
        // Add the desktop script
        var desktopScript = document.createElement("script");
        desktopScript.src = desktopWebAdvertisementScriptUrl;
        desktopScript.id = DESKTOP_FOOTPRINTS_SCRIPT_ID;
        desktopScript.async = true;
        desktopScript.onload = setDesktopScriptLoaded(true);
        // Append scripts to the document body
        document.body.appendChild(mobileScript);
        document.body.appendChild(desktopScript);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        loadScript();
        return function() {
            // Cleanup scripts on component unmount
            var mobileScript = document.getElementById(MOBILE_FOOTPRINTS_SCRIPT_ID);
            var desktopScript = document.getElementById(DESKTOP_FOOTPRINTS_SCRIPT_ID);
            if (mobileScript) {
                document.body.removeChild(mobileScript);
            }
            if (desktopScript) {
                document.body.removeChild(desktopScript);
            }
        };
    }, []);
    var scriptsLoaded = mobileScriptLoaded || desktopScriptLoaded;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(scriptsLoaded ? "flex justify-center items-center py-[20px]" : "invisible"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "ffrWebAdvertising".concat(desktopSize, "Desktop")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "ffrWebAdvertising".concat(mobileSize, "Mobile")
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FootprintsWebAdsBanner);


/***/ }),

/***/ 12311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ List; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(15722);
// EXTERNAL MODULE: ./components/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(94512);
// EXTERNAL MODULE: ./components/ContentEditorView/index.js + 24 modules
var ContentEditorView = __webpack_require__(51961);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
;// CONCATENATED MODULE: ./components/Subcategories.js








var ref = (0,config["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, _settings = _publicRuntimeConfig.settings, baseUrl = _settings.baseUrl, websiteName = _settings.websiteName;
var Subcategories = function(param) {
    var subcategories = param.subcategories;
    if (subcategories && subcategories.length > 0) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "flex flex-wrap -mx-1 md:-mx-2 py-6",
            children: subcategories.map(function(subcategory) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                    className: "w-1/2 md:w-1/3 lg:w-1/5 p-1 md:p-2",
                    children: subcategory.url_absolute ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: subcategory.url_absolute,
                        title: "",
                        className: classnames_default()("bg-white rounded-tr-lg rounded-bl-lg min-h-260px lg:min-h-320px flex flex-col h-full p-4 text-center", {
                            "border border-gray-1100 hover:shadow-mixRedYellow": websiteName !== "bricostore",
                            "shadow-raised sm:hover:shadow-raised-hover": websiteName === "bricostore"
                        }),
                        children: [
                            subcategory.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,helpers/* resizeImage */.tg)(subcategory.thumbnail, "300x300"),
                                className: "flex-none w-90px h-90px md:w-120px md:h-120px mx-auto mt-10",
                                alt: subcategory.seo_alt_text || subcategory.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h4",
                                title: subcategory.name,
                                classesProp: "break-words mt-5 text-[22px] leading-20 -tracking-0.36"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "".concat(baseUrl, "/").concat(subcategory.url_key, "/cpl/"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: classnames_default()("bg-white rounded-tr-lg rounded-bl-lg min-h-260px lg:min-h-320px flex flex-col h-full p-4 text-center", {
                                "border border-gray-1100 hover:shadow-mixRedYellow": websiteName !== "bricostore",
                                "shadow-raised sm:hover:shadow-raised-hover": websiteName === "bricostore"
                            }),
                            children: [
                                subcategory.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,helpers/* resizeImage */.tg)(subcategory.thumbnail, "300x300"),
                                    className: "flex-none w-90px h-90px md:w-120px md:h-120px mx-auto mt-10",
                                    alt: subcategory.seo_alt_text || subcategory.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    as: "h2",
                                    display: "h4",
                                    title: subcategory.name,
                                    classesProp: "break-words mt-5 text-[22px] leading-20 -tracking-0.36"
                                })
                            ]
                        })
                    })
                }, subcategory.id);
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
        type: "info",
        showIcon: true,
        children: "Nu exista subcategorii"
    }));
};
/* harmony default export */ var components_Subcategories = (Subcategories);

;// CONCATENATED MODULE: ./components/ScrollableSubcategories.js







var ScrollableSubcategories_ref = (0,config["default"])(), ScrollableSubcategories_publicRuntimeConfig = ScrollableSubcategories_ref.publicRuntimeConfig, ScrollableSubcategories_settings = ScrollableSubcategories_publicRuntimeConfig.settings, ScrollableSubcategories_baseUrl = ScrollableSubcategories_settings.baseUrl, ScrollableSubcategories_websiteName = ScrollableSubcategories_settings.websiteName;
var ScrollableSubcategories = function(param) {
    var subcategories = param.subcategories;
    if (subcategories && subcategories.length > 0) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: "flex md:flex-wrap -mx-1 md:-mx-2 pt-6 pb-3 md:pb-6 overflow-x-scroll md:overflow-x-auto scrollbar ".concat(ScrollableSubcategories_websiteName === "bricostore" ? "scrollbar-thumb-red-brand" : "scrollbar-thumb-filterYellow", " scrollbar-track-[#F1F1F1] scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-h-1"),
            children: subcategories.map(function(subcategory) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                    className: "p-1 md:p-2",
                    children: subcategory.url_absolute ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: subcategory.url_absolute,
                        title: "",
                        className: classnames_default()("bg-white min-h-[200px] rounded-lg w-[140px] md:w-[180px] flex flex-col items-center justify-center space-y-4 h-full text-center", {
                            "border border-gray-1100 hover:shadow-mixRedYellow": ScrollableSubcategories_websiteName !== "bricostore",
                            "shadow-raised sm:hover:shadow-raised-hover": ScrollableSubcategories_websiteName === "bricostore"
                        }),
                        children: [
                            subcategory.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,helpers/* resizeImage */.tg)(subcategory.thumbnail, "300x300"),
                                className: "flex-none w-[100px] h-[100px] md:w-[110px] md:h-[110px] mx-auto",
                                alt: subcategory.seo_alt_text || subcategory.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h2",
                                display: "h4",
                                title: subcategory.name,
                                classesProp: "break-words line-clamp-2 max-w-[120px] md:max-w-[140px] leading-[22px] text-lg -tracking-1"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "".concat(ScrollableSubcategories_baseUrl, "/").concat(subcategory.url_key, "/cpl/"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: classnames_default()("bg-white rounded-lg md:w-[180px] flex flex-col items-center justify-center space-y-4 h-full text-center w-[140px] min-h-[200px]", {
                                "border border-gray-1100 hover:shadow-mixRedYellow": ScrollableSubcategories_websiteName !== "bricostore",
                                "shadow-raised sm:hover:shadow-raised-hover": ScrollableSubcategories_websiteName === "bricostore"
                            }),
                            children: [
                                subcategory.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,helpers/* resizeImage */.tg)(subcategory.thumbnail, "300x300"),
                                    className: "flex-none w-[100px] h-[100px] md:w-[110px] md:h-[110px] mx-auto",
                                    alt: subcategory.seo_alt_text || subcategory.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    as: "h2",
                                    display: "h4",
                                    title: subcategory.name,
                                    classesProp: "break-words line-clamp-2 max-w-[120px] md:max-w-[140px] leading-[22px] text-lg -tracking-1"
                                })
                            ]
                        })
                    })
                }, subcategory.id);
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
        type: "info",
        showIcon: true,
        children: "Nu exista subcategorii"
    }));
};
/* harmony default export */ var components_ScrollableSubcategories = (ScrollableSubcategories);

// EXTERNAL MODULE: ./components/ProductList/index.js + 2 modules
var ProductList = __webpack_require__(75866);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/ExpandableProductList.js + 1 modules
var ExpandableProductList = __webpack_require__(4761);
// EXTERNAL MODULE: ./store/pages/actions.js + 1 modules
var actions = __webpack_require__(94308);
;// CONCATENATED MODULE: ./components/NoSearchResultsRecommendations.js








function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var NoSearchResultsRecommendations = function(param) {
    var onProductClick = param.onProductClick, getCatalogPromotions1 = param.getCatalogPromotions;
    var ref, ref1;
    var ref2 = (0,react.useState)(), productRecommendations = ref2[0], setProductRecommendations = ref2[1];
    (0,react.useEffect)(function() {
        var getProductRecommendations = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getCatalogPromotions1(5);
                        case 2:
                            response = _ctx.sent;
                            if (response === null || response === void 0 ? void 0 : response.data) setProductRecommendations(response.data);
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function getProductRecommendations() {
                return _ref.apply(this, arguments);
            };
        }();
        getProductRecommendations();
    }, [
        getCatalogPromotions1
    ]);
    if (!productRecommendations) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            ((ref = productRecommendations.promotions) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h2",
                        display: "h1",
                        title: "Promotii",
                        classesProp: "mb-4 pt-6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableProductList/* default */.Z, {
                        products: productRecommendations.promotions.map(function(product, index) {
                            return _objectSpread({}, product, {
                                index: index + 1,
                                item_list_name: "promotii"
                            });
                        }),
                        desktopVisibleProducts: 10,
                        onProductClick: function(product) {
                            return onProductClick(product);
                        }
                    })
                ]
            }),
            ((ref1 = productRecommendations.top_offer) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        as: "h2",
                        display: "h1",
                        title: "Top oferte",
                        classesProp: "mb-4 pt-6"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableProductList/* default */.Z, {
                        products: productRecommendations.top_offer.map(function(product, index) {
                            return _objectSpread({}, product, {
                                index: index + 1,
                                item_list_name: "top oferte"
                            });
                        }),
                        desktopVisibleProducts: 10,
                        onProductClick: function(product) {
                            return onProductClick(product);
                        }
                    })
                ]
            })
        ]
    }));
};
NoSearchResultsRecommendations.propTypes = {
    onProductClick: (prop_types_default()).func.isRequired
};
/* harmony default export */ var components_NoSearchResultsRecommendations = ((0,es/* connect */.$j)(null, {
    getCatalogPromotions: actions/* getCatalogPromotions */.l
})(NoSearchResultsRecommendations));

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./lib/filterUtil.js
var filterUtil = __webpack_require__(82594);
// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__(12280);
// EXTERNAL MODULE: ./store/app/actions.js
var app_actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./components/Filters/ActiveFilters.js + 1 modules
var ActiveFilters = __webpack_require__(86517);
// EXTERNAL MODULE: ./components/Filters/FilterGroup.js + 2 modules
var FilterGroup = __webpack_require__(68533);
// EXTERNAL MODULE: ./lib/GTMHelper.js
var GTMHelper = __webpack_require__(17242);
;// CONCATENATED MODULE: ./components/Filters/index.js












function Filters_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Filters_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Filters_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var Filters_ref = (0,config["default"])(), Filters_publicRuntimeConfig = Filters_ref.publicRuntimeConfig, Filters_websiteName = Filters_publicRuntimeConfig.settings.websiteName;
var isBricoStore = Filters_websiteName === "bricostore";
// Filter footer buttons: bricostore uses the pill button system; altex/MG keep the yellow style.
var FILTER_APPLY_CLASS = isBricoStore ? "py-2 px-5 text-14px text-center w-full text-white bg-red-brand rounded-full" : "py-2 px-5 text-14px border-2 border-transparent bg-filterYellow w-full rounded-bl-lg rounded-tr-lg";
var FILTER_RESET_CLASS = isBricoStore ? "py-2 px-5 text-14px text-center w-full bg-red-soft border border-red-brand text-red-brand rounded-full" : "py-2 px-5 text-center text-14px border-2 border-filterYellow w-full rounded-bl-lg rounded-tr-lg";
var Filters = function(param) {
    var extractedFiltersParams = param.extractedFiltersParams, filters = param.filters, activeFilters = param.activeFilters, totalProducts = param.totalProducts, removeModal1 = param.removeModal, isInSearch = param.isInSearch, query = param.query;
    var hasActiveFilters = Boolean(activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length);
    var trackFilterChange = function(filter1) {
        var operation = filter1.filters.length === 0 || filter1.filters.every(function(filter) {
            return filter.isActive;
        }) ? "remove" : "add";
        if (operation === "add") {
            (0,GTMHelper/* setGTMProductsFilterApply */.xr)({
                addedFilters: filter1,
                activeFilters: activeFilters
            });
        } else {
            (0,GTMHelper/* setGTMProductsFilterRemove */.bO)({
                removedFilters: filter1,
                activeFilters: activeFilters
            });
        }
    };
    var handleFilterMobileApply = function(parentSlug, filter, generalSlugs) {
        var filQuery = Filters_objectSpread({}, extractedFiltersParams.filters);
        // we remove existing values for this filter group as we always send all active values in the callback
        parentSlug ? delete filQuery[parentSlug] : generalSlugs.forEach(function(slug) {
            return delete filQuery[slug];
        });
        var url = (0,filterUtil/* addRemoveUrl */.jk)("add", filter.filters.map(function(filterOption) {
            return {
                filter: filterOption.attributeSlug || parentSlug,
                filterValue: filterOption.slug,
                replaceValue: false
            };
        }), filQuery, isInSearch ? "search" : "list", query || {});
        trackFilterChange(filter);
        removeModal1();
        router["default"].push(url);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block lg:w-1/5 lg:mt-3 sm:pr-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "Filters",
                    id: "catalog-filters-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: filters.map(function(filter, index) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterGroup/* default */.Z, {
                                filter: filter,
                                isModal: false,
                                isLast: index == filters.length - 1,
                                onFilterMobileApply: handleFilterMobileApply,
                                activeFilters: activeFilters
                            }, index);
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal["default"], {
                id: "filters",
                header: "Filtreaza",
                hasStickyHeader: true,
                hasStickyFooter: true,
                hasRadius: false,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex space-x-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: FILTER_APPLY_CLASS,
                                onClick: function() {
                                    return removeModal1();
                                },
                                children: [
                                    "Vezi ",
                                    totalProducts,
                                    " ",
                                    totalProducts !== 1 ? "produse" : "produs"
                                ]
                            }),
                            hasActiveFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                href: activeFilters.find(function(el) {
                                    return el.removeAll;
                                }).removeUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: FILTER_RESET_CLASS,
                                    onClick: function() {
                                        return removeModal1();
                                    },
                                    children: "Sterge tot"
                                })
                            })
                        ]
                    })
                }),
                children: [
                    hasActiveFilters && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Filters-group Filters-group--remove js-active-filters mb-4 ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveFilters/* default */.Z, {
                            activeFilters: activeFilters
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:mt-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "Filters",
                            id: "catalog-filters-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: filters.map(function(filter, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(FilterGroup/* default */.Z, {
                                        filter: filter,
                                        isModal: true,
                                        onFilterMobileApply: handleFilterMobileApply,
                                        isLast: index == filters.length - 1,
                                        activeFilters: activeFilters
                                    }, index);
                                })
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
Filters.propTypes = {
    filters: (prop_types_default()).array.isRequired,
    extractedFiltersParams: (prop_types_default()).object.isRequired
};
/* harmony default export */ var components_Filters = ((0,es/* connect */.$j)(null, {
    removeModal: app_actions/* removeModal */.a_
})(Filters));

// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
;// CONCATENATED MODULE: ./components/Sort.js











function Sort_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Sort_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Sort_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Sort_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Sort = function(param) {
    var toolbar = param.toolbar, modal = param.modal, addModal = param.addModal, urlPath = param.urlPath, apiCall1 = param.apiCall, removeModal = param.removeModal;
    var ref = (0,react.useState)(toolbar), toolbarState = ref[0], setToolbarState = ref[1];
    var ref1 = (0,react.useState)(null), selectedSort = ref1[0], setSelectedSort = ref1[1];
    var rebuildToolbar = function() {
        var _ref = Sort_asyncToGenerator(runtime_default().mark(function _callee(url) {
            var filters, isSearch, requestFilters, extractedFiltersParams, response2, toolbarNew, response1, toolbarNew1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        filters = url.split("filtru/")[1];
                        isSearch = url.includes("cauta");
                        requestFilters = filters.split("/").filter(function(x) {
                            return x;
                        });
                        extractedFiltersParams = (0,filterUtil/* extractFiltersParams */.Nl)(requestFilters);
                        if (!isSearch) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 7;
                        return apiCall1({
                            apiArgs: [
                                {
                                    searchTerm: urlPath,
                                    apiQuery: extractedFiltersParams.apiQueryParams
                                }, 
                            ],
                            apiCall: api/* searchApi */.UeX,
                            formatResponse: function(response) {
                                return response.data;
                            },
                            returnResponse: true
                        });
                    case 7:
                        response2 = _ctx.sent;
                        if (response2) {
                            toolbarNew = (0,filterUtil/* makeToolbar */.Np)(response2.meta, "search", extractedFiltersParams, urlPath);
                            setToolbarState(toolbarNew);
                        }
                        _ctx.next = 15;
                        break;
                    case 11:
                        _ctx.next = 13;
                        return apiCall1({
                            apiArgs: [
                                urlPath,
                                extractedFiltersParams.apiQueryParams
                            ],
                            apiCall: api/* getCategoryApi */.eQd,
                            formatResponse: function(response) {
                                return response.data;
                            },
                            returnResponse: true
                        });
                    case 13:
                        response1 = _ctx.sent;
                        if (response1) {
                            toolbarNew1 = (0,filterUtil/* makeToolbar */.Np)(response1.meta, "category", extractedFiltersParams, urlPath);
                            setToolbarState(toolbarNew1);
                        }
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function rebuildToolbar(url) {
            return _ref.apply(this, arguments);
        };
    }();
    var getSelected = function(coll, justIndex) {
        var activeUrlIndex = coll.findIndex(function(elem) {
            return elem.active === true;
        });
        if (activeUrlIndex === -1) {
            activeUrlIndex = coll.findIndex(function(elem) {
                return elem.default === true;
            });
        }
        if (justIndex) {
            return activeUrlIndex;
        }
        if (activeUrlIndex === -1) {
            return false;
        }
        return "".concat(coll[activeUrlIndex].url);
    };
    var trackSortChange = function(url) {
        var newSortOption = toolbar.sort.find(function(x) {
            return x.url === url;
        });
        (0,GTMHelper/* setGTMProductsSortOptions */.pN)(newSortOption.name);
    };
    if (modal) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
            id: "toolbar",
            onRemoveModal: function() {
                return setToolbarState(toolbar);
            },
            header: "Sorteaza",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "Toolbar flow-root Toolbar--modal",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "Form-select",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                value: getSelected(toolbarState.sort),
                                className: "!max-w-lg mx-auto block",
                                onChange: function() {
                                    var _ref = Sort_asyncToGenerator(runtime_default().mark(function _callee(e) {
                                        return runtime_default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    _ctx.next = 2;
                                                    return rebuildToolbar(e.target.value);
                                                case 2:
                                                    setSelectedSort(e.target.value);
                                                case 3:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(e) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(),
                                children: toolbarState.sort.map(function(option) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                        value: "".concat(option.url),
                                        children: option.name
                                    }, option.url);
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 max-w-lg mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: Sort_asyncToGenerator(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return removeModal();
                                        case 2:
                                            if (selectedSort) {
                                                trackSortChange(selectedSort);
                                                router["default"].push(selectedSort);
                                            }
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })),
                            variant: "primary",
                            title: "Aplica",
                            display: "block"
                        })
                    })
                ]
            })
        }));
    } else {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "Toolbar pb-4 mt-15px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid grid-cols-2 gap-4 justify-between lg:hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "flex justify-center items-center py-2 px-5 border rounded-bl-lg rounded-tr-lg border-primary text-black",
                            onClick: function() {
                                return addModal("filters");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pr-2 flex-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        width: "19",
                                        height: "17",
                                        viewBox: "0 0 19 17",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            fillRule: "evenodd",
                                            clipRule: "evenodd",
                                            d: "M18 1H0L7.2 9.40889V15.2222L10.8 17V9.40889L18 1V1Z",
                                            stroke: "black",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                }),
                                "Filtreaza"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            className: "flex justify-center items-center py-2 px-5 border rounded-bl-lg rounded-tr-lg border-primary text-black",
                            onClick: function() {
                                return addModal("toolbar");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "pr-2 flex-none",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        width: "21",
                                        height: "17",
                                        viewBox: "0 0 21 17",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                                id: "path-1-inside-1",
                                                fill: "white",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    width: "21",
                                                    height: "5",
                                                    rx: "1"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                width: "21",
                                                height: "5",
                                                rx: "1",
                                                stroke: "black",
                                                strokeWidth: "4",
                                                mask: "url(#path-1-inside-1)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                                id: "path-2-inside-2",
                                                fill: "white",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    y: "6",
                                                    width: "17",
                                                    height: "5",
                                                    rx: "1"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                y: "6",
                                                width: "17",
                                                height: "5",
                                                rx: "1",
                                                stroke: "black",
                                                strokeWidth: "4",
                                                mask: "url(#path-2-inside-2)"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("mask", {
                                                id: "path-3-inside-3",
                                                fill: "white",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                    y: "12",
                                                    width: "13",
                                                    height: "5",
                                                    rx: "1"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                                y: "12",
                                                width: "13",
                                                height: "5",
                                                rx: "1",
                                                stroke: "black",
                                                strokeWidth: "4",
                                                mask: "url(#path-3-inside-3)"
                                            })
                                        ]
                                    })
                                }),
                                "Sorteaza"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hidden lg:inline-flex items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Form-select w-[220px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                            value: getSelected(toolbar.sort),
                            className: "!max-w-lg mx-auto block",
                            onChange: function() {
                                var _ref = Sort_asyncToGenerator(runtime_default().mark(function _callee(e) {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                trackSortChange(e.target.value);
                                                router["default"].push(e.target.value);
                                                window.scrollTo(0, 0);
                                            case 3:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(e) {
                                    return _ref.apply(this, arguments);
                                };
                            }(),
                            children: toolbar.sort.map(function(option) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("option", {
                                    value: "".concat(option.url),
                                    children: option.name
                                }, option.url);
                            })
                        })
                    })
                })
            ]
        }));
    }
};
/* harmony default export */ var components_Sort = ((0,es/* connect */.$j)(null, {
    apiCall: app_actions/* apiCall */.k_
})(Sort));

// EXTERNAL MODULE: ./store/tracker/actions.js + 1 modules
var tracker_actions = __webpack_require__(48712);
// EXTERNAL MODULE: ./containers/Catalog/CompareWidget.js + 1 modules
var CompareWidget = __webpack_require__(1144);
// EXTERNAL MODULE: ./components/Banners.js
var Banners = __webpack_require__(225);
// EXTERNAL MODULE: ./store/catalog/actions.js
var catalog_actions = __webpack_require__(35493);
// EXTERNAL MODULE: ./components/PaginationWithLinks/index.js + 2 modules
var PaginationWithLinks = __webpack_require__(78880);
// EXTERNAL MODULE: ./components/Footprints/FootprintsWebAdsBanner.js
var FootprintsWebAdsBanner = __webpack_require__(42009);
// EXTERNAL MODULE: ./components/CredexUserPromoBanner/index.js + 2 modules
var CredexUserPromoBanner = __webpack_require__(87246);
;// CONCATENATED MODULE: ./containers/Catalog/List.js



























function List_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function List_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            List_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var List_ref = (0,config["default"])(), settings = List_ref.publicRuntimeConfig.settings;
var CatalogList = function(props1) {
    var ref2;
    var layout = props1.layout, query = props1.query, currentUrl = props1.currentUrl, _featureFlags = props1.featureFlags, featureFlags = _featureFlags === void 0 ? null : _featureFlags, user = props1.user;
    var _currentCategory = props1.currentCategory, _breadcrumbs = _currentCategory.breadcrumbs, breadcrumbs = _breadcrumbs === void 0 ? [] : _breadcrumbs, products = _currentCategory.products, filters = _currentCategory.filters, activeFilters = _currentCategory.activeFilters, meta = _currentCategory.meta;
    // prettier-ignore
    var ref1 = props1.currentCategory.category || props1.currentCategory.search, _display_mode = ref1.display_mode, display_mode = _display_mode === void 0 ? "PRODUCTS" : _display_mode, _meta_title = ref1.meta_title, meta_title = _meta_title === void 0 ? layout === "search" ? "Rezultate cautare: ".concat(query.q) : "" : _meta_title, _meta_description = ref1.meta_description, meta_description = _meta_description === void 0 ? "" : _meta_description, _meta_keywords = ref1.meta_keywords, meta_keywords = _meta_keywords === void 0 ? "" : _meta_keywords, meta_robots = ref1.meta_robots, seo_canonical = ref1.seo_canonical, _seo_alternate_canonical = ref1.seo_alternate_canonical, seo_alternate_canonical = _seo_alternate_canonical === void 0 ? "" : _seo_alternate_canonical, seo_title = ref1.seo_title, _name = ref1.name, name = _name === void 0 ? layout === "search" ? "Rezultate cautare".concat(query.q && query.q.length <= 36 ? ": " + query.q : "") : "" : _name, _description = ref1.description, description = _description === void 0 ? null : _description, _description_editor_object = ref1.description_editor_object, description_editor_object = _description_editor_object === void 0 ? null : _description_editor_object, subcategories = ref1.subcategories, landing_page = ref1.landing_page, banners = ref1.banners;
    var showFootprintsBanner = Boolean((featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableFootprints) && (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableFootprintsBanner) && layout !== "search");
    var hasCredexUserPromo = ((ref2 = user.customer) === null || ref2 === void 0 ? void 0 : ref2.has_promo) === "CC12RATE";
    var parsedDescriptionObject;
    if (description_editor_object) {
        try {
            parsedDescriptionObject = JSON.parse(description_editor_object);
        } catch (error) {
            parsedDescriptionObject = false;
        }
    }
    if (layout === "search") {
        breadcrumbs.push({
            name: name,
            id: 99,
            level: 99
        });
    }
    var handleProductClick = function(product, options) {
        props1.trackProductClick(product, options);
    };
    var Meta = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(head["default"], {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: meta_title || name || ""
                }),
                meta_description.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: meta_description
                }),
                meta_keywords.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "keywords",
                    content: meta_keywords
                }),
                props1.currentCategory.category && !!props1.currentCategory.category.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "og:image",
                    content: (0,helpers/* resizeImage */.tg)(props1.currentCategory.category.thumbnail, "600x600")
                }),
                (meta_robots === null || meta_robots === void 0 ? void 0 : meta_robots.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "robots",
                    content: meta_robots
                }),
                layout === "search" || seo_canonical && !(seo_alternate_canonical === null || seo_alternate_canonical === void 0 ? void 0 : seo_alternate_canonical.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "canonical",
                    href: currentUrl
                }),
                !(layout === "search") && seo_canonical && (seo_alternate_canonical === null || seo_alternate_canonical === void 0 ? void 0 : seo_alternate_canonical.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "alternate",
                    href: seo_alternate_canonical
                })
            ]
        });
    };
    (0,react.useEffect)(function() {
        if ((products === null || products === void 0 ? void 0 : products.length) > 0) {
            (0,GTMHelper/* setGTMProductsImpressions */.SS)(products.map(function(product, index) {
                var ref3;
                return List_objectSpread({}, product, {
                    index: index + 1
                }, layout !== "search" ? {
                    categoryPath: breadcrumbs,
                    item_list_name: breadcrumbs === null || breadcrumbs === void 0 ? void 0 : (ref3 = breadcrumbs[breadcrumbs.length - 1]) === null || ref3 === void 0 ? void 0 : ref3.name
                } : {
                    item_list_name: "Rezultate cautare"
                });
            }));
        }
    }, [
        products,
        breadcrumbs,
        layout
    ]);
    var Content = function() {
        if (display_mode === "PAGE") {
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    landing_page && landing_page.content ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: landing_page.content
                        }
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Subcategories, {
                        subcategories: subcategories
                    }),
                    showFootprintsBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(FootprintsWebAdsBanner/* default */.Z, {})
                ]
            }));
        } else {
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    subcategories && subcategories.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ScrollableSubcategories, {
                        subcategories: subcategories
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActiveFilters/* default */.Z, {
                                activeFilters: activeFilters
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Sort, {
                                addModal: props1.addModal,
                                removeModal: props1.removeModal,
                                urlPath: props1.urlPath,
                                toolbar: props1.currentCategory.toolbar,
                                params: props1.extractedFiltersParams.otherParams,
                                meta: props1.currentCategory.meta
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "lg-u-display-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "Filters-mobile-active js-mobile-active-filters"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductList/* default */.Z, {
                                products: products.map(function(product, index) {
                                    var ref4;
                                    return List_objectSpread({}, product, {
                                        index: index + 1
                                    }, layout !== "search" ? {
                                        categoryPath: breadcrumbs,
                                        item_list_name: breadcrumbs === null || breadcrumbs === void 0 ? void 0 : (ref4 = breadcrumbs[breadcrumbs.length - 1]) === null || ref4 === void 0 ? void 0 : ref4.name
                                    } : {
                                        item_list_name: "Rezultate cautare"
                                    });
                                }),
                                filter: props1.extractedFiltersParams,
                                containerClass: "Products flex flex-wrap relative",
                                onProductClick: handleProductClick,
                                listType: layout
                            }),
                            get_default()(props1, "currentCategory.toolbar.paginationBottom", []).length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaginationWithLinks/* default */.Z, {
                                            pagination: props1.currentCategory.toolbar.paginationBottom
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-center mt-1",
                                        children: props1.currentCategory.meta.items === 1 ? "".concat(props1.currentCategory.meta.items, " produs") : "".concat(props1.currentCategory.meta.items, " produse")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Sort, {
                                addModal: props1.addModal,
                                removeModal: props1.removeModal,
                                urlPath: props1.urlPath,
                                toolbar: props1.currentCategory.toolbar,
                                params: props1.extractedFiltersParams.otherParams,
                                meta: props1.currentCategory.meta,
                                modal: true
                            })
                        ]
                    })
                ]
            }));
        }
    };
    var ListLayout = function(props) {
        if (display_mode !== "PAGE") {
            var totalProducts = (meta === null || meta === void 0 ? void 0 : meta.items) || 0;
            var ref5;
            return products && products.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Filters, {
                        activeFilters: activeFilters,
                        filters: filters,
                        extractedFiltersParams: props.extractedFiltersParams,
                        query: query,
                        totalProducts: totalProducts,
                        isInSearch: layout && layout === "search"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(products.length !== 0 ? "lg:w-4/5" : "lg:mt-8", " "),
                        children: [
                            hasCredexUserPromo && /*#__PURE__*/ (0,jsx_runtime.jsx)(CredexUserPromoBanner/* default */.Z, {}),
                            display_mode !== "PAGE" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("block md:flex md:items-baseline", {
                                    "px-[16px] py-[8px]": settings.websiteName === "bricostore"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        as: "h1",
                                        title: seo_title || name,
                                        display: "h1",
                                        sameSizeOnMobile: true
                                    }),
                                    totalProducts !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()("md:ml-2 font-normal text-22px leading-7", {
                                            "text-gray-light": settings.websiteName !== "bricostore",
                                            "text-[#9F9FA9]": settings.websiteName === "bricostore"
                                        }),
                                        children: [
                                            "(",
                                            totalProducts,
                                            " ",
                                            totalProducts === 1 ? "produs" : "produse",
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            showFootprintsBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(FootprintsWebAdsBanner/* default */.Z, {}),
                            props.children
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col md:flex-row items-center justify-center md:justify-start gap-6 my-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "w-[158px]",
                        src: "".concat(settings.websiteStatics, "/images/cart/empty-cart.svg"),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        title: seo_title || layout === "search" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "Ne pare rau, cautarea ta ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                    children: [
                                        "\"",
                                        (ref5 = query === null || query === void 0 ? void 0 : query.q) !== null && ref5 !== void 0 ? ref5 : "",
                                        "\""
                                    ]
                                }),
                                " ",
                                "nu a avut niciun rezultat. Verifica daca ai scris corect sau incearca sa cauti folosind alt termen."
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Nu au fost gasite produse conform criteriilor selectate."
                        }),
                        as: "h1",
                        display: "h6",
                        classesProp: "max-w-[639px]"
                    })
                ]
            });
        }
        return props.children;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Meta, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                breadcrumbs: breadcrumbs
            }),
            products !== undefined && products.length > 0 && display_mode === "PAGE" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                as: "h1",
                title: seo_title || name,
                display: "h1"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListLayout, {
                extractedFiltersParams: props1.extractedFiltersParams,
                urlPath: props1.urlPath,
                fetchCurrentCategory: props1.fetchCurrentCategory,
                children: [
                    banners && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            banners[0].images_mobile && banners[0].images_mobile.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners/* default */.Z, {
                                    items: banners[0].images_mobile
                                })
                            }),
                            banners[0].images_tablet && banners[0].images_tablet.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden sm:block lg:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners/* default */.Z, {
                                    items: banners[0].images_tablet
                                })
                            }),
                            banners[0].images && banners[0].images.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden lg:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners/* default */.Z, {
                                    items: banners[0].images
                                })
                            })
                        ]
                    }),
                    landing_page && landing_page.content ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: landing_page.content
                        }
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {}),
                    props1.extractedFiltersParams && props1.extractedFiltersParams.filters && Object.keys(props1.extractedFiltersParams.filters).length === 0 && props1.extractedFiltersParams.otherParams && Object.keys(props1.extractedFiltersParams.otherParams).length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: parsedDescriptionObject ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentEditorView/* default */.Z, {
                            content: parsedDescriptionObject
                        }) : (description === null || description === void 0 ? void 0 : description.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-10",
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        })
                    })
                ]
            }),
            layout && layout === "search" && (!products || products.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NoSearchResultsRecommendations, {
                onProductClick: handleProductClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompareWidget/* default */.Z, {})
        ]
    }));
};
/* harmony default export */ var List = ((0,es/* connect */.$j)(function(state) {
    return {
        currentCategory: state.catalog.currentCategory,
        urlPath: state.catalog.urlPath,
        user: state.user,
        extractedFiltersParams: state.catalog.extractedFiltersParams,
        featureFlags: state.app.websiteAdminConfigs.featureFlagsWebsite
    };
}, {
    addModal: app_actions/* addModal */.Y_,
    removeModal: app_actions/* removeModal */.a_,
    trackProductClick: tracker_actions/* trackProductClick */.Cg,
    getCategory: catalog_actions/* getCategory */.n3,
    getMoreCategory: catalog_actions/* getMoreCategory */.W7,
    getMoreSearch: catalog_actions/* getMoreSearch */.fr
})(CatalogList));


/***/ })

}]);